import { render, staticRenderFns } from "./LongGrassModal.vue?vue&type=template&id=225d6aa6&"
import script from "./LongGrassModal.vue?vue&type=script&lang=js&"
export * from "./LongGrassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports